import React, { useMemo } from 'react';
import { useAuth } from '@guildeducationinc/guild-auth';
import { StudentFundingWidget } from '@guildeducationinc/student-funding-widget';
import CoachContactCard from '@src/components/GuildSupport/CoachContactCard/CoachContactCard';
import GeneralContactCard from '@src/components/GuildSupport/GeneralContactCard/GeneralContactCard';
import StudentLoanCard from '@src/components/StudentLoan/StudentLoanCard/StudentLoanCard';
import YourClasses from '@src/components/YourClasses/YourClasses';
import { useMemberPlanContext } from '@src/context/MemberPlanContext';
import EligibilityWidget from '@src/remotes/EligibilityWidget/EligibilityWidget';
import { PRODUCT } from '@src/constants';
import './Sidebar.scss';
import useECornellSSOLinks from '@src/hooks/useECornellSSOLinks';
import useGetMemberUser from '@src/hooks/useGetMemberUser';

const Sidebar: React.FC = () => {
  const { user } = useAuth();
  const { memberPlan } = useMemberPlanContext();
  const { memberUser } = useGetMemberUser();
  const { data: ssoLinkData } = useECornellSSOLinks();

  const displayYourClasses = useMemo(() => {
    return !!ssoLinkData?.ssoLink;
  }, [ssoLinkData]);

  const coachingLink = memberUser?.coachingLinks?.growthCoachingLink;

  const displayStudentLoanCard =
    memberPlan?.hasStudentLoanReimbursement || memberPlan?.hasStudentLoanOptimization;

  return (
    <div className='sidebar' aria-label='sidebar'>
      <StudentFundingWidget productName='home' user={user} analytics={window.analytics} />
      {displayYourClasses && <YourClasses />}
      {user && (
        <div className='eligibilityWidgetWrapper'>
          <EligibilityWidget analytics={window.analytics} productName={PRODUCT} user={user} />
        </div>
      )}
      {displayStudentLoanCard && <StudentLoanCard />}
      {coachingLink && <CoachContactCard coachCalendlyLink={coachingLink} />}
      <GeneralContactCard />
    </div>
  );
};

export default Sidebar;
